// Navbar.js
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./navbar.css"; // Import the CSS file
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import PendingIcon from "@mui/icons-material/Pending";

const Navbar = () => {
  const [activeIndex, setActiveIndex] = useState(0); // Track the active link
  const [circlePosition, setCirclePosition] = useState(); // Default position for the circle
  const navigate = useNavigate(); // Initialize useNavigate
  const location = useLocation();
  const links = useMemo(
    () => [
      { id: 0, icon: <PendingIcon />, route: "/" },
      { id: 1, icon: <ThumbUpIcon />, route: "/Accepted" }, // Add route property
    ],
    []
  ); // Empty dependency array, so links won't change unless necessary
  useEffect(() => {
    const currentLinkIndex = links.findIndex(
      (link) => link.route === location.pathname
    );
    if (currentLinkIndex !== -1) {
      setActiveIndex(currentLinkIndex);
      setCirclePosition(`${80 * currentLinkIndex}px`);
    }
  }, [location.pathname, links]);
  const handleClick = (index) => {
    setActiveIndex(index);
    setCirclePosition(`${80 * index}px`);

    // Navigate to the route if defined
    if (links[index].route) {
      navigate(links[index].route);
    }
  };

  return (
    <div className="navbar">
      <ul>
        {links.map((link, index) => (
          <li
            key={link.id}
            onClick={() => handleClick(index)} // Handle click event
          >
            {link.icon}
          </li>
        ))}
        <div id="circle" style={{ left: circlePosition }}>
          {activeIndex !== null && links[activeIndex].icon}{" "}
          {/* Show the icon of the active link */}
        </div>
      </ul>
    </div>
  );
};

export default Navbar;
